import http from "@/http/aisea/axios";
const resource = "/enterprises/crews";

export default {
  fetchList(enterpriseCrewId, payload) {
    return http.get(`${resource}/${enterpriseCrewId}/having_licenses`, {
      params: payload,
    });
  },

  fetchById(enterpriseCrewId, id) {
    return http.get(`${resource}/${enterpriseCrewId}/having_licenses/${id}`);
  },

  add(enterpriseCrewId, payload) {
    return http.post(
      `${resource}/${enterpriseCrewId}/having_licenses`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  update(enterpriseCrewId, id, payload) {
    return http.put(
      `${resource}/${enterpriseCrewId}/having_licenses/${id}`,
      payload,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },

  delete(enterpriseCrewId, id) {
    return http.delete(`${resource}/${enterpriseCrewId}/having_licenses/${id}`);
  },
};
